/**
 * Crasman multiselect.
 * Documentation: https://git.crasmanhosting.fi/npm/multiselect/
 *
 * Same options can be defined as data-attributes if needed.
 * Related styles: _multiselect.scss
 */
import Multiselect from '@crasman/multiselect';

const defaultSettings = {
  listElement: {
    size: 12
  },
  buttonElement: {
    showPlaceholder: true
  }
};

const multiselect = {
  init() {
    document.querySelectorAll('select.js--multiselect').forEach(select => {
      const selectSettings = select.dataset;
      new Multiselect(select, {...defaultSettings, ...selectSettings});
    });
  }
};

export default multiselect;
